import { pilotOrNotPilot, replaceableJobTitles } from "./constants";

export const isPilot = (userJobTitle: string) => {
    return replaceableJobTitles.includes(userJobTitle.toLowerCase()) ? pilotOrNotPilot.pilot : pilotOrNotPilot.nonPilot;
};

export const capitalize = (text: string) => {
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export const savePathNamesArrayToSessionStorage = () => {
    const pathName = window.location.pathname;
    const pathNames = JSON.parse(sessionStorage.getItem("pathNames") || "[]");
    pathNames.push(pathName);
    sessionStorage.setItem("pathNames", JSON.stringify(pathNames));
    
};

export const removeLastPathNameFromSessionStorage = () => {
    const pathNames = JSON.parse(sessionStorage.getItem("pathNames") || "[]");
    if (pathNames.length > 0) {
        pathNames.pop();
        sessionStorage.setItem("pathNames", JSON.stringify(pathNames));
    }
};